import { G2S } from '../g2s';
import * as api from '../api';

export class FlightService {
    agencyTerms(request: api.FlightTermsRequest): Promise<api.ContentText> {
        return new Promise<api.ContentText>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Flight/AgencyTerms',
                    request,
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.ContentText>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    search(request: api.FlightSearchRequest): Promise<api.FlightSearchResult> {
        return new Promise<api.FlightSearchResult>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Flight/Search',
                    request,
                    {
                        withCredentials: true
                    }
                )
                .then(function(response) {
                    resolve(<api.FlightSearchResult>response.data);
                })
                .catch(function(error) {
                    reject(error);
                });
        });
    }

    searchArchive(request: api.FlightSearchIdRequest): Promise<api.FlightSearchResult> {
        return new Promise<api.FlightSearchArchiveResult>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Flight/Results',
                    request,
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.FlightSearchArchiveResult>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    fareDetails(request: api.FareDetailsRequest): Promise<api.FareDetailsResponse> {
        return new Promise<api.FareDetailsResponse>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Flight/FareDetails',
                    request,
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.FareDetailsResponse>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    externalLink(request: api.ExternalLinkRequest): Promise<api.ExternalLinkResponse> {
        return new Promise<api.ExternalLinkResponse>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Flight/ExternalLink',
                    request,
                    {
                        withCredentials: true
                    }
                )
                .then((response) => {
                    resolve(<api.ExternalLinkResponse>response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}
